<template>
  <card-prime id="card-prime">
    <template #content>
      <div id="envio">
        <div class="formgrid grid">
          <div class="flex field col-12 md:col-12">
            <div class="flex flex-row flex-wrap">
              <InputSwitch
                id="selecionar-AceiteLgpd"
                v-model="Interesse.AceiteLgpd"
              />
            </div>
            <div class="flex flex-wrap align-items-center card-container pl-3">
              <span class="text-left text-sm vertical-align-text-bottom">
                Ao utilizar este site, você concorda com a coleta e tratamento de
                seus dados pessoais por meio de formulários e cookies, segundo o que
                estabelece a LGPD (Lei Geral de Proteção de Dados).
              </span>
            </div>
          </div>
        </div>
        <div class="formgrid grid">
          <div class="field col-12 md:col-3"></div>
          <div class="col-12">
            <div
              v-if="exibirMensagemErro">
              <MessagePrime severity="error" :life="15000" :sticky="false" :key="mensagemId">{{mensagemErro}}</MessagePrime>
            </div>
          </div>
          <div class="field col-12 md:col-3"></div>
          <div class="field col-12 md:col-6">
            <ButtonPrime          
              v-if="exibirBotaoEnviar"
              type="submit"
              v-bind:disabled="permiteEnviar"
              id="botao-enviar-interesse"
              label="Enviar"
            />
          </div>
        </div>
      </div>
    </template>
  </card-prime>
</template>

<script>
import { useInteresseStore } from "@/store/interesse";
import { storeToRefs } from "pinia";
import InputSwitch from "primevue/inputswitch";
import ButtonPrime from "primevue/button";
import MessagePrime from "primevue/message";
import CardPrime from "primevue/card";

export default {
  name: "EnvioComponent",

  props: {
    exibirMensagemErro: {
      type: Boolean,
      default: false,
    },
    exibirBotaoEnviar: {
      type: Boolean,
      default: true,
    },
    mensagemErro: {
      type: String,
      default: "",
    },
    mensagemId: {
      type: Number,
      default: 0
    }
  },

  setup() {
    const storeInteresse = useInteresseStore();
    const { Interesse } = storeToRefs(storeInteresse);
    return { Interesse };
  },

  components: {
    InputSwitch,
    ButtonPrime,
    MessagePrime,
    CardPrime,
  },

  computed: {
    permiteEnviar() {
      return !this.Interesse.AceiteLgpd;
    },
  }
};
</script>